var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MapViewer',{attrs:{"format":_vm.format,"publisherId":_vm.publisherId,"mapId":_vm.mapId,"lang":_vm.lang,"customSearchButtonLabel":_vm.customSearchButtonLabel,"topLeftBounds":_vm.parsedTopLeft,"bottomRightBounds":_vm.parsedBottomRight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }